import moment from "moment";

const formatDate = (dateString) => {
  if (!dateString) return "";
  return moment(dateString, "YYYY-MM-DD").format("DD-MM-YYYY");
};

export default formatDate;
